import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { aiAuditLogsPluginKey } from './ai-audit-log-plugin-key';
import { MAX_RETIRES, RETRY_DELAY } from './constants';
import { reducer } from './reducer';
function onDocChanged(tr, pluginState) {
  var eventState = pluginState['ai-generated-content-inserted'];
  if (eventState.eventStatus === 'not-sent' && tr.getMeta('isAiContentTransformation')) {
    return _objectSpread(_objectSpread({}, pluginState), {}, {
      'ai-generated-content-inserted': _objectSpread(_objectSpread({}, eventState), {}, {
        eventStatus: 'send-event'
      })
    });
  }
  return pluginState;
}
export var createInitialState = function createInitialState(eventData) {
  return function (_state) {
    return {
      'ai-generated-content-inserted': {
        eventStatus: 'not-sent',
        retries: 0
      },
      'aup-violation': {
        eventStatus: 'not-sent',
        retries: 0
      },
      maxRetries: MAX_RETIRES,
      retryDelay: RETRY_DELAY,
      eventData: eventData
    };
  };
};
var _pluginFactory = pluginFactory(aiAuditLogsPluginKey, reducer, {
    onDocChanged: onDocChanged
  }),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export { createPluginState, createCommand, getPluginState };